import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import VAnimateCss from 'v-animate-css'

Vue.use(VAnimateCss)
Vue.component(FeatherIcon.name, FeatherIcon)
